// Static snapshot cloned into Firestore for each demo session.
// coachId is injected at write time — not stored here.
// Players use stable IDs (dp_*) so game stats can reference them by ID.

export const DEMO_TEAM_TEMPLATE = {
  name: 'Riverside Thunder',
  ageGroup: '12U',
  level: 'AAA',
  styleOfPlay: 'playerspitch',
  org: 'little_league',
  season: 'Spring',
  seasonYear: 2026,
  joinCode: 'DEMO01',
  // Demo team logo — file lives in /public/demo-logos/riverside-thunder.png.
  // The Riverside Thunder is the fictional team in the 2-hour demo session;
  // their logo gives the demo a polished, real-team feel that's better than
  // the generic Trophy fallback.
  logoURL: '/demo-logos/riverside-thunder.png',
  settings: {
    fieldTimeEqualizerEnabled: true,
    noConsecutiveBench: true,
    noConsecutivePosition: false,
    minFieldInningsEnabled: false,
    minFieldInningsPerPlayer: 2,
    equalBenchInnings: true,
    mustPlayInfieldEnabled: false,
    mustPlayInfieldInnings: 2,
    fourOutfielders: false,
    noPitcher: false,
    noCatcher: false,
    battingOrderStyle: 'Continuous',
    useDH: false,
    battingStrategy: 'Optimized',
    mandatoryAB: false,
    entireSeasonLineup: false,
    showRecordOnDashboard: true,
    enforcePitchCounts: true,
    pitchCountRuleset: 'little_league',
    pitchCountAgeGroup: '12U',
    enforceGlobalRest: true,
    maxPitchesPerDayEnabled: false,
    maxPitchesPerDay: 85,
    maxInningsPerGameEnabled: false,
    maxInningsPerGame: 6,
    maxInningsPerDayEnabled: false,
    maxInningsPerDay: 6,
    maxInningsPerWeekEnabled: false,
    maxInningsPerWeek: 9,
    noConsecutiveDaysPitching: false,
    maxAppearancesPer3DaysEnabled: false,
    maxAppearancesPer3Days: 2,
    tournamentsOperateIndependently: true,
    noPitcherReentry: false,
    excludeCatcherFromBullpen: false,
    catcherToPitcherRestriction: true,
    pitcherToCatcherRestriction: true,
    pitchCountBlocksCatching: 41,
    trackGameBalls: false,
    latePlayerTracking: false,
    scrimmagePitchCounts: false,
  },
};

export const DEMO_PLAYERS_TEMPLATE = [
  {
    id: 'dp_rivera',
    name: 'Marcus Rivera',
    number: '2',
    primaryPosition: 'SS',
    secondaryPosition: 'P',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 4, eye: 3, approach: 4 },
      fielding:    { glove: 5, arm: 4, block: 3 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 5, iq: 4, clutch: 5 },
    },
    positions: { P: 3, C: 0, SS: 5, '2B': 3, '3B': 3, '1B': 2, LF: 2, CF: 3, RF: 2 },
    pitchingLog: [{ date: '2026-03-15', pitchCount: 42, inningsPitched: 3, gameId: 'g1' }],
    stats: { gp: 11, pa: 38, ab: 31, avg: 0.355, obp: 0.447, ops: 0.923, h: 11, bb: 6, so: 5, rbi: 8, r: 10 },
  },
  {
    id: 'dp_thompson',
    name: 'Jake Thompson',
    number: '14',
    primaryPosition: 'P',
    secondaryPosition: '1B',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 5, eye: 3, approach: 4 },
      fielding:    { glove: 4, arm: 5, block: 2 },
      pitching:    { velocity: 5, control: 5 },
      intangibles: { speed: 4, iq: 5, clutch: 5 },
    },
    positions: { P: 5, C: 0, SS: 1, '2B': 1, '3B': 2, '1B': 3, LF: 2, CF: 1, RF: 2 },
    pitchingLog: [
      { date: '2026-03-22', pitchCount: 68, inningsPitched: 5, gameId: 'g2' },
      { date: '2026-04-05', pitchCount: 74, inningsPitched: 5, gameId: 'g4' },
    ],
    stats: { gp: 10, pa: 28, ab: 24, avg: 0.292, obp: 0.357, ops: 0.81, h: 7, bb: 3, so: 8, rbi: 6, r: 4 },
  },
  {
    id: 'dp_brooks',
    name: 'Tyler Brooks',
    number: '7',
    primaryPosition: 'C',
    secondaryPosition: '3B',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 4, eye: 4, approach: 3 },
      fielding:    { glove: 5, arm: 5, block: 4 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 3, iq: 5, clutch: 5 },
    },
    positions: { P: 0, C: 5, SS: 1, '2B': 2, '3B': 3, '1B': 3, LF: 2, CF: 1, RF: 2 },
    pitchingLog: [],
    stats: { gp: 11, pa: 32, ab: 27, avg: 0.333, obp: 0.406, ops: 0.88, h: 9, bb: 4, so: 7, rbi: 9, r: 5 },
  },
  {
    id: 'dp_martinez',
    name: 'Dylan Martinez',
    number: '4',
    primaryPosition: '2B',
    secondaryPosition: 'SS',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 5, power: 2, eye: 5, approach: 2 },
      fielding:    { glove: 4, arm: 4, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 5, iq: 5, clutch: 3 },
    },
    positions: { P: 0, C: 0, SS: 3, '2B': 5, '3B': 2, '1B': 2, LF: 3, CF: 2, RF: 3 },
    pitchingLog: [],
    stats: { gp: 11, pa: 35, ab: 29, avg: 0.31, obp: 0.4, ops: 0.812, h: 9, bb: 5, so: 4, rbi: 4, r: 8 },
  },
  {
    id: 'dp_walsh',
    name: 'Connor Walsh',
    number: '21',
    primaryPosition: '3B',
    secondaryPosition: '1B',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 5, eye: 4, approach: 5 },
      fielding:    { glove: 4, arm: 5, block: 3 },
      pitching:    { velocity: 4, control: 5 },
      intangibles: { speed: 3, iq: 5, clutch: 5 },
    },
    positions: { P: 2, C: 0, SS: 1, '2B': 2, '3B': 5, '1B': 4, LF: 3, CF: 1, RF: 2 },
    pitchingLog: [{ date: '2026-04-19', pitchCount: 35, inningsPitched: 2, gameId: 'g6' }],
    stats: { gp: 10, pa: 30, ab: 25, avg: 0.28, obp: 0.333, ops: 0.862, h: 7, bb: 4, so: 9, rbi: 11, r: 5 },
  },
  {
    id: 'dp_park',
    name: 'Ethan Park',
    number: '8',
    primaryPosition: 'CF',
    secondaryPosition: '2B',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 2, eye: 4, approach: 3 },
      fielding:    { glove: 5, arm: 4, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 5, iq: 5, clutch: 4 },
    },
    positions: { P: 0, C: 0, SS: 2, '2B': 3, '3B': 2, '1B': 1, LF: 4, CF: 5, RF: 4 },
    pitchingLog: [],
    stats: { gp: 11, pa: 36, ab: 30, avg: 0.3, obp: 0.389, ops: 0.763, h: 9, bb: 5, so: 6, rbi: 3, r: 11 },
  },
  {
    id: 'dp_garcia',
    name: 'Noah Garcia',
    number: '17',
    primaryPosition: 'RF',
    secondaryPosition: 'P',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 3, eye: 4, approach: 2 },
      fielding:    { glove: 4, arm: 5, block: 2 },
      pitching:    { velocity: 4, control: 4 },
      intangibles: { speed: 4, iq: 4, clutch: 3 },
    },
    positions: { P: 4, C: 0, SS: 2, '2B': 2, '3B': 2, '1B': 2, LF: 3, CF: 3, RF: 4 },
    pitchingLog: [
      { date: '2026-03-29', pitchCount: 28, inningsPitched: 2, gameId: 'g3' },
      { date: '2026-04-12', pitchCount: 55, inningsPitched: 4, gameId: 'g5' },
    ],
    stats: { gp: 11, pa: 30, ab: 25, avg: 0.24, obp: 0.3, ops: 0.66, h: 6, bb: 4, so: 8, rbi: 5, r: 4 },
  },
  {
    id: 'dp_johnson',
    name: 'Liam Johnson',
    number: '11',
    primaryPosition: 'LF',
    secondaryPosition: '3B',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 3, eye: 3, approach: 3 },
      fielding:    { glove: 4, arm: 4, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 4, iq: 4, clutch: 3 },
    },
    positions: { P: 0, C: 0, SS: 1, '2B': 2, '3B': 3, '1B': 3, LF: 5, CF: 3, RF: 4 },
    pitchingLog: [],
    stats: { gp: 10, pa: 27, ab: 22, avg: 0.227, obp: 0.296, ops: 0.598, h: 5, bb: 4, so: 7, rbi: 3, r: 4 },
  },
  {
    id: 'dp_davis',
    name: 'Owen Davis',
    number: '33',
    primaryPosition: '1B',
    secondaryPosition: 'LF',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 4, eye: 4, approach: 4 },
      fielding:    { glove: 4, arm: 4, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 3, iq: 5, clutch: 3 },
    },
    positions: { P: 0, C: 0, SS: 0, '2B': 1, '3B': 2, '1B': 5, LF: 4, CF: 1, RF: 3 },
    pitchingLog: [],
    stats: { gp: 11, pa: 29, ab: 24, avg: 0.25, obp: 0.31, ops: 0.72, h: 6, bb: 4, so: 9, rbi: 7, r: 3 },
  },
  {
    id: 'dp_wilson',
    name: 'Caleb Wilson',
    number: '5',
    primaryPosition: 'P',
    secondaryPosition: 'SS',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 3, eye: 3, approach: 4 },
      fielding:    { glove: 4, arm: 5, block: 2 },
      pitching:    { velocity: 5, control: 5 },
      intangibles: { speed: 4, iq: 5, clutch: 4 },
    },
    positions: { P: 5, C: 0, SS: 3, '2B': 2, '3B': 2, '1B': 2, LF: 2, CF: 2, RF: 2 },
    pitchingLog: [{ date: '2026-04-26', pitchCount: 62, inningsPitched: 4, gameId: 'g8' }],
    stats: { gp: 10, pa: 24, ab: 20, avg: 0.25, obp: 0.333, ops: 0.683, h: 5, bb: 3, so: 6, rbi: 3, r: 4 },
  },
  {
    id: 'dp_lee',
    name: 'Mason Lee',
    number: '19',
    primaryPosition: '3B',
    secondaryPosition: 'RF',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 3, power: 3, eye: 3, approach: 2 },
      fielding:    { glove: 4, arm: 3, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 4, iq: 4, clutch: 3 },
    },
    positions: { P: 0, C: 0, SS: 1, '2B': 2, '3B': 3, '1B': 3, LF: 3, CF: 2, RF: 4 },
    pitchingLog: [],
    stats: { gp: 9, pa: 20, ab: 17, avg: 0.176, obp: 0.25, ops: 0.546, h: 3, bb: 2, so: 6, rbi: 2, r: 2 },
  },
  {
    id: 'dp_chen',
    name: 'Aidan Chen',
    number: '23',
    primaryPosition: '2B',
    secondaryPosition: 'CF',
    isGuest: false,
    guestActive: true,
    attributes: {
      hitting:     { contact: 4, power: 2, eye: 4, approach: 3 },
      fielding:    { glove: 4, arm: 3, block: 2 },
      pitching:    { velocity: 0, control: 0 },
      intangibles: { speed: 5, iq: 4, clutch: 4 },
    },
    positions: { P: 0, C: 0, SS: 2, '2B': 4, '3B': 2, '1B': 2, LF: 3, CF: 4, RF: 3 },
    pitchingLog: [],
    stats: { gp: 10, pa: 22, ab: 18, avg: 0.222, obp: 0.318, ops: 0.608, h: 4, bb: 3, so: 5, rbi: 2, r: 5 },
  },
];

// ─── Per-game stats helpers ─────────────────────────────────────────────────
//
// Each per-game line includes raw counting stats plus a hit-type breakdown
// (singles_1b/_2b/_3b/_hr) — `withBattingRates` computes avg, obp, slg, ops,
// and xbh from those so the aggregator in App.tsx has the rate stats it needs.
//
// Pitching lines include ip + outcome counters; `withPitchingRates` computes
// era, whip, plus realistic pitches/bf/sPct/fpsPct fields.

interface BatLine {
  pa: number; ab: number; h: number; bb: number; so: number; rbi: number; r: number;
  _2b?: number; _3b?: number; hr?: number; hbp?: number; sb?: number;
}

interface PitchLine {
  ip: number; er: number; soAllowed: number; bbAllowed: number; hAllowed: number;
  hrAllowed?: number; hbpAllowed?: number;
  // Optional override for pitch count. If provided, it's used directly so the
  // per-game total matches the pitchingLog the coach already saw. If omitted,
  // the count is modeled from IP + outcomes.
  pitches?: number;
}

type StatLine = (BatLine & Partial<PitchLine>) | null;

function withBattingRates(line: BatLine & Partial<PitchLine>): any {
  const ab = line.ab || 0;
  const h = line.h || 0;
  const bb = line.bb || 0;
  const hbp = line.hbp || 0;
  const doubles = line._2b || 0;
  const triples = line._3b || 0;
  const hr = line.hr || 0;
  const singles = Math.max(0, h - doubles - triples - hr);
  const totalBases = singles + 2 * doubles + 3 * triples + 4 * hr;
  const xbh = doubles + triples + hr;
  const avg = ab > 0 ? h / ab : 0;
  const obp = (ab + bb + hbp) > 0 ? (h + bb + hbp) / (ab + bb + hbp) : 0;
  const slg = ab > 0 ? totalBases / ab : 0;
  const ops = obp + slg;
  return {
    pa: line.pa, ab, h, bb, so: line.so || 0, rbi: line.rbi || 0, r: line.r || 0,
    xbh, sb: line.sb || 0, hbp,
    avg, obp, slg, ops,
  };
}

function withPitchingRates(line: PitchLine): any {
  const ip = line.ip || 0;
  const er = line.er || 0;
  const soAllowed = line.soAllowed || 0;
  const bbAllowed = line.bbAllowed || 0;
  const hAllowed = line.hAllowed || 0;
  const hrAllowed = line.hrAllowed || 0;
  const hbpAllowed = line.hbpAllowed || 0;
  // Approximate batters faced from outcomes: 3 outs per inning + baserunners.
  const outs = Math.round(ip * 3);
  const bf = outs + hAllowed + bbAllowed + hbpAllowed;
  // Use the explicit pitch count when provided (matches pitchingLog exactly);
  // otherwise model from IP + baserunners at ~13.5 P/IP for 12U.
  const pitches = line.pitches != null
    ? line.pitches
    : Math.round(ip * 13.5 + bbAllowed * 2 + hAllowed * 1);
  // Strike percentage: better outings = higher strike %. We model it from
  // K and BB rates — high K / low BB = good strike-throwing day.
  const strikeRate = Math.min(0.72, Math.max(0.48,
    0.58 + (soAllowed - bbAllowed * 1.5) * 0.015
  ));
  // First-pitch strike %: similar but slightly more volatile.
  const fpsRate = Math.min(0.78, Math.max(0.45,
    0.6 + (soAllowed - bbAllowed * 2) * 0.018
  ));
  const era = ip > 0 ? (er * 7) / ip : 0; // 7-inning game ERA convention
  const whip = ip > 0 ? (hAllowed + bbAllowed) / ip : 0;
  // Output both `er` (legacy) and `erAllowed` (canonical, used by StatsView's
  // team-ER aggregator). Same for the other counted outcomes — the canonical
  // *Allowed suffix is what the rest of the app reads.
  return {
    ip,
    er, erAllowed: er,
    soAllowed, bbAllowed, hAllowed,
    hrAllowed, hbpAllowed,
    pitches, bf,
    sPct: strikeRate,
    fpsPct: fpsRate,
    era, whip,
  };
}

function combine(bat: BatLine, pitch?: PitchLine): any {
  const b = withBattingRates(bat);
  if (!pitch) return b;
  return { ...b, ...withPitchingRates(pitch) };
}

// ─── Per-game per-player stats keyed by stable player ID ────────────────────

const S: Record<string, StatLine[]> = {
  // Rivera: .355 AVG across 11 games. Pitches g1 (3 IP, 42 pitches).
  dp_rivera: [
    combine({ pa:4, ab:3, h:2, bb:1, so:0, rbi:1, r:2, _2b:1 }, { ip:3, er:2, soAllowed:3, bbAllowed:1, hAllowed:3, pitches:42 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:0, rbi:2, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:4, ab:3, h:2, bb:1, so:0, rbi:1, r:2, _2b:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:1 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:0, r:1 }),
    combine({ pa:4, ab:3, h:2, bb:1, so:0, rbi:2, r:1, _3b:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:1, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:0, rbi:0, r:0 }),
  ],
  // Thompson: ace pitcher, .292 hitter, started g2 and g4.
  dp_thompson: [
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:1, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0, _2b:1 }, { ip:5, er:3, soAllowed:5, bbAllowed:2, hAllowed:6, pitches:68 }),
    combine({ pa:3, ab:2, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:2, rbi:2, r:1, _2b:1 }, { ip:5, er:1, soAllowed:6, bbAllowed:1, hAllowed:4, pitches:74 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:1, r:1 }),
    null,
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:1 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:0, bb:1, so:0, rbi:0, r:0 }),
  ],
  // Brooks (C): .333 AVG, top RBI catcher.
  dp_brooks: [
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:1, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:2, r:1, _2b:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:4, ab:2, h:2, bb:1, so:0, rbi:2, r:1, _2b:1, hbp:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:1, r:1 }),
    combine({ pa:4, ab:3, h:0, bb:1, so:1, rbi:0, r:0 }),
  ],
  // Walsh (3B): cleanup hitter — 11 RBI, 1 HR, also pitched g6.
  dp_walsh: [
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:2, r:0, _2b:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:2, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:2, r:1, hr:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:0, ab:0, h:0, bb:0, so:0, rbi:0, r:0 }, { ip:2, er:1, soAllowed:2, bbAllowed:2, hAllowed:3, pitches:35 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:2, r:1, _2b:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:2, r:1, _2b:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
  ],
  // Park (CF): .300 AVG, table-setter, 11 runs scored.
  dp_park: [
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:1 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:4, ab:2, h:1, bb:1, so:0, rbi:1, r:2, _2b:1, sb:1, hbp:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:4, ab:3, h:2, bb:1, so:0, rbi:1, r:2, _2b:1, sb:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:0, r:2, sb:1 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:0, rbi:0, r:1 }),
  ],
  // Martinez (2B): .310 AVG, contact hitter, 8 runs.
  dp_martinez: [
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:0, r:1 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:4, ab:3, h:1, bb:1, so:0, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:1, r:2 }),
  ],
  // Garcia (RF/P): .240 hitter, pitched g3 and g5.
  dp_garcia: [
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:3, ab:2, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:1, r:0 }, { ip:2, er:2, soAllowed:2, bbAllowed:2, hAllowed:3, pitches:28 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }, { ip:4, er:2, soAllowed:4, bbAllowed:3, hAllowed:5, pitches:55 }),
    combine({ pa:3, ab:2, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:2, r:1, _2b:1 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:0, r:1 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:2, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
  ],
  // Johnson (LF): .227 AVG.
  dp_johnson: [
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:0, rbi:1, r:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:1 }),
    null,
    combine({ pa:3, ab:2, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:0, h:0, bb:2, so:1, rbi:0, r:0 }),
  ],
  // Davis (1B): power hitter, .250 / 7 RBI, slight HR upside.
  dp_davis: [
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:1, r:0 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:0, _2b:1 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:2, r:1, hr:1 }),
    combine({ pa:3, ab:3, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:2, h:1, bb:0, so:0, rbi:1, r:1, hbp:1 }),
    combine({ pa:3, ab:2, h:1, bb:1, so:1, rbi:1, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:3, ab:3, h:1, bb:0, so:1, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:0, h:0, bb:2, so:1, rbi:0, r:0 }),
  ],
  // Wilson (P/SS): pitched g8 (loss), .250 hitter.
  dp_wilson: [
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:0, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:1, h:0, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:1, r:0 }, { ip:4, er:4, soAllowed:3, bbAllowed:3, hAllowed:6, hrAllowed:1, pitches:62 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:0, r:0 }),
    combine({ pa:2, ab:1, h:0, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:0, rbi:0, r:0 }),
  ],
  // Lee (3B): .176 — cold streak, 0-for-9 the last 5 games.
  dp_lee: [
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:1, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    null,
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:1, h:0, bb:1, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:0, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:0, rbi:0, r:0 }),
  ],
  // Chen (2B): .222 AVG, contact bat, decent OBP.
  dp_chen: [
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:0, r:1 }),
    combine({ pa:2, ab:1, h:0, bb:1, so:1, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:0, rbi:1, r:0 }),
    null,
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:1, h:1, bb:1, so:0, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:1, rbi:0, r:0 }),
    combine({ pa:2, ab:2, h:1, bb:0, so:1, rbi:1, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:0, so:0, rbi:0, r:1 }),
    combine({ pa:2, ab:2, h:0, bb:1, so:0, rbi:0, r:0 }),
  ],
};

const GAME_IDS = ['g1','g2','g3','g4','g5','g6','g7','g8','g9','g10','g11'];

// Game outcomes (must mirror DEMO_GAMES_TEMPLATE below) — the story-stat
// derivations lean on these so the Winning Formula's wins-vs-losses gaps
// tell a coherent story (losses = more walks that score, fewer quality ABs).
const OUTCOMES: ('W' | 'L')[] = ['W','W','L','W','W','L','W','L','W','L','W'];

// ─── Story-stat enrichment (2026-07 Season Dashboard) ───────────────────────
//
// The dashboard reads GameChanger's "story stats" (QAB, hard-hit balls,
// BA/RISP, pitches seen, FPS outcome splits, walks-that-scored…). Real teams
// get these from CSV imports; the demo derives them deterministically from
// each line's raw counts so every session ships with the full story populated.
// Deterministic (seeded by player+game) so demo screenshots are stable.

/** Tiny seeded PRNG (fnv-1a seed → xorshift-ish stream), stable per player+game. */
function demoRng(seedStr: string): () => number {
  let h = 2166136261;
  for (let i = 0; i < seedStr.length; i++) { h ^= seedStr.charCodeAt(i); h = Math.imul(h, 16777619); }
  return () => {
    h = Math.imul(h ^ (h >>> 15), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  };
}

// Per-player contact profiles [LD%, GB%, FB%] + clutch BA/RISP + hard-hit bias.
// Tuned for the Hitter Truth narrative: Lee squares balls up but has nothing to
// show for it (→ "Due"); Rivera's .355 rides soft fly balls (→ "Riding luck").
const STORY_PROFILE: Record<string, { mix: [number, number, number]; risp: number; hhbBias: number }> = {
  dp_rivera:   { mix: [13, 33, 54], risp: 0.310, hhbBias: 0.0 },
  dp_thompson: { mix: [22, 46, 32], risp: 0.340, hhbBias: 0.2 },
  dp_brooks:   { mix: [24, 44, 32], risp: 0.430, hhbBias: 0.3 },
  dp_walsh:    { mix: [23, 40, 37], risp: 0.400, hhbBias: 0.4 },
  dp_park:     { mix: [20, 52, 28], risp: 0.330, hhbBias: 0.1 },
  dp_martinez: { mix: [21, 50, 29], risp: 0.360, hhbBias: 0.1 },
  dp_garcia:   { mix: [17, 48, 35], risp: 0.250, hhbBias: 0.0 },
  dp_johnson:  { mix: [23, 49, 28], risp: 0.240, hhbBias: 0.1 },
  dp_davis:    { mix: [19, 38, 43], risp: 0.290, hhbBias: 0.3 },
  dp_wilson:   { mix: [18, 50, 32], risp: 0.270, hhbBias: 0.0 },
  dp_lee:      { mix: [30, 44, 26], risp: 0.150, hhbBias: 0.6 },
  dp_chen:     { mix: [19, 53, 28], risp: 0.230, hhbBias: 0.0 },
};

const clampN = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));

function enrichStoryStats(line: any, pid: string, gameIdx: number): any {
  const rng = demoRng(`${pid}|${GAME_IDS[gameIdx]}`);
  const outcome = OUTCOMES[gameIdx];
  const prof = STORY_PROFILE[pid] ?? { mix: [20, 46, 34] as [number, number, number], risp: 0.280, hhbBias: 0.1 };
  const out: any = { ...line };

  // ── Batting story stats (only when the player batted) ──
  if ((line.pa || 0) > 0) {
    const pa = line.pa, ab = line.ab || 0, h = line.h || 0, bb = line.bb || 0;
    const so = line.so || 0, hbp = line.hbp || 0, rbi = line.rbi || 0;

    const battles = Math.min(Math.max(0, pa - h - bb - hbp), (rng() < (outcome === 'W' ? 0.55 : 0.3) ? 1 : 0));
    out.qab = Math.min(pa, h + bb + hbp + battles);
    out.twoStrikeBattle = Math.min(pa, battles + (so > 0 && rng() < 0.45 ? 1 : 0));
    out.ps = Math.round(pa * (3.4 + rng() * 1.0));
    out.kLooking = so > 0 ? Math.round(so * (rng() < 0.38 ? 0.5 : 0.25)) : 0;
    out.twoOutRbi = rbi > 0 ? clampN(Math.round(rbi * (0.25 + rng() * 0.35)), 0, rbi) : 0;
    out.lob = clampN(Math.round(rng() * pa * 0.8), 0, 4);
    out.hhb = clampN(Math.round(h * 0.55 + prof.hhbBias + rng() * 0.9), 0, Math.max(h, 2));
    if (ab > 0) out.contactPct = ((ab - so) / ab) * 100;
    // Contact mix (GC exports these as 0–100 percentages) with small game jitter
    const [ld, gb] = prof.mix;
    const jitter = Math.round(rng() * 6 - 3);
    out.ldPct = clampN(ld + jitter, 5, 45);
    out.gbPct = clampN(gb - jitter, 20, 65);
    out.fbPct = 100 - out.ldPct - out.gbPct;
    // BA/RISP: profile constant ± small jitter (season-weighted ≈ the profile)
    out.baRisp = clampN(prof.risp + (rng() * 0.06 - 0.03), 0, 1);
  }

  // ── Pitching story stats (only when the player pitched) ──
  if ((line.ip || 0) > 0) {
    const ip = line.ip, bbA = line.bbAllowed || 0, soA = line.soAllowed || 0;
    const hA = line.hAllowed || 0, bf = line.bf || Math.round(ip * 3) + hA + bbA;
    const loss = outcome === 'L';

    out.rAllowed = (line.erAllowed ?? line.er ?? 0) + (rng() < 0.35 ? 1 : 0);
    out.bbs = clampN(Math.round(bbA * (loss ? 0.55 : 0.3) + rng() * 0.6), 0, bbA);
    out.lobb = bbA > 0 && rng() < 0.4 ? 1 : 0;
    out.zeroBbInn = Math.max(0, Math.floor(ip) - Math.min(bbA, Math.floor(ip)));
    out.inn123 = bbA <= 1 && hA <= ip && rng() < 0.55 ? 1 : 0;
    out.lowPitchInn = ((line.pitches || 0) / Math.max(ip, 1)) < 15 ? 1 : (rng() < 0.3 ? 1 : 0);
    out.loo = clampN(Math.round(ip * 0.35 + rng()), 0, 3);
    // FPS outcome splits (0–100 shares of first-pitch-strike at-bats)
    const fpso = clampN(Math.round(44 + soA * 3 - bbA * 3 + rng() * 8), 28, 62);
    const fpsh = clampN(Math.round(16 + rng() * 8), 10, 26);
    const fpsw = clampN(Math.round(94 - fpso - fpsh - rng() * 8), 6, 34);
    out.fpsoPct = fpso; out.fpshPct = fpsh; out.fpswPct = fpsw;
    out.smPct = clampN(Math.round((7 + soA * 1.2 + rng() * 3) * 10) / 10, 4, 18);
    out.kBf = bf > 0 ? soA / bf : 0;
    out.weakPct = Math.round(35 + rng() * 20);
    out.baa = clampN(hA / Math.max(1, bf - bbA - (line.hbpAllowed || 0)), 0, 1);
    out.goAo = Math.round((0.9 + rng() * 1.2) * 10) / 10;
  }

  return out;
}

// Build the stats map for each completed game: { [gameId]: { [playerId]: statLine } }
function buildGameStats(): Record<string, Record<string, any>> {
  const result: Record<string, Record<string, any>> = {};
  GAME_IDS.forEach((gid, i) => {
    result[gid] = {};
    for (const [pid, lines] of Object.entries(S)) {
      const line = lines[i];
      if (line) result[gid][pid] = enrichStoryStats(line, pid, i);
    }
  });
  return result;
}

const GAME_STATS = buildGameStats();

// ─── Inning logs (fairness data) ────────────────────────────────────────────
//
// Generate per-inning fielding lineups for each completed game so the Fairness
// view and the Field Time Equalizer have data to display. Every player is
// placed at their preferred position when possible and benched in a rotating
// pattern so total bench innings are roughly equal across the roster. The
// pitcher slot follows the per-game pitcher rotation defined below.

const PLAYER_ORDER = [
  'dp_rivera', 'dp_thompson', 'dp_brooks', 'dp_martinez', 'dp_walsh', 'dp_park',
  'dp_garcia', 'dp_johnson', 'dp_davis', 'dp_wilson', 'dp_lee', 'dp_chen',
];

const PRIMARY_POSITION: Record<string, string> = {
  dp_rivera: 'SS', dp_thompson: 'P', dp_brooks: 'C', dp_martinez: '2B',
  dp_walsh: '3B', dp_park: 'CF', dp_garcia: 'RF', dp_johnson: 'LF',
  dp_davis: '1B', dp_wilson: 'P', dp_lee: '3B', dp_chen: '2B',
};

// Who pitches inning-by-inning per game. Length 6 (12U games are 6 innings).
// Derived from each player's pitchingLog so the pitcher in the lineup matches
// the pitcher with the IP totals.
const PITCHERS_BY_GAME: Record<string, string[]> = {
  g1:  ['dp_rivera',   'dp_rivera',   'dp_rivera',   'dp_wilson',   'dp_wilson',   'dp_wilson'],
  g2:  ['dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_walsh'],
  g3:  ['dp_garcia',   'dp_garcia',   'dp_walsh',    'dp_walsh',    'dp_wilson',   'dp_wilson'],
  g4:  ['dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_garcia'],
  g5:  ['dp_garcia',   'dp_garcia',   'dp_garcia',   'dp_garcia',   'dp_wilson',   'dp_wilson'],
  g6:  ['dp_walsh',    'dp_walsh',    'dp_garcia',   'dp_garcia',   'dp_wilson',   'dp_wilson'],
  g7:  ['dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_wilson',   'dp_wilson',   'dp_rivera'],
  g8:  ['dp_wilson',   'dp_wilson',   'dp_wilson',   'dp_wilson',   'dp_walsh',    'dp_walsh'],
  g9:  ['dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_garcia',   'dp_garcia',   'dp_rivera'],
  g10: ['dp_wilson',   'dp_wilson',   'dp_walsh',    'dp_walsh',    'dp_garcia',   'dp_garcia'],
  g11: ['dp_thompson', 'dp_thompson', 'dp_thompson', 'dp_wilson',   'dp_wilson',   'dp_walsh'],
};

// Position assignment fallbacks for innings where a player is pulled off
// their primary spot (typically when their primary is taken by another
// player rotating through). Roughly matches each player's listed positions
// in the roster.
const FALLBACK_POSITIONS: Record<string, string[]> = {
  dp_rivera:   ['SS', '2B', '3B', 'CF'],
  dp_thompson: ['P', '1B', '3B'],
  dp_brooks:   ['C', '1B', '3B'],
  dp_martinez: ['2B', 'SS', 'LF'],
  dp_walsh:    ['3B', '1B', 'LF', 'P'],
  dp_park:     ['CF', 'RF', '2B'],
  dp_garcia:   ['RF', 'CF', 'LF', 'P'],
  dp_johnson:  ['LF', 'RF', '1B'],
  dp_davis:    ['1B', 'LF', '3B'],
  dp_wilson:   ['P', 'SS', '2B'],
  dp_lee:      ['3B', 'RF', '1B'],
  dp_chen:     ['2B', 'CF', 'SS'],
};

// Players who sat out individual games (matches the null entries in S above).
const ABSENT_BY_GAME: Record<string, string[]> = {
  g1:  [],
  g2:  [],
  g3:  [],
  g4:  ['dp_lee'],
  g5:  ['dp_johnson', 'dp_chen'],
  g6:  ['dp_thompson'],
  g7:  [],
  g8:  [],
  g9:  [],
  g10: [],
  g11: [],
};

function generateInningLogsForGame(gameId: string, gameIdx: number): Record<string, any[]> {
  const pitcherByInning = PITCHERS_BY_GAME[gameId] || [];
  const absent = new Set(ABSENT_BY_GAME[gameId] || []);
  const available = PLAYER_ORDER.filter(pid => !absent.has(pid));
  const logs: Record<string, any[]> = {};

  // Rotate the bench window across the season so over 11 games every player
  // accumulates a similar number of bench innings. With 3 bench slots per
  // inning × 6 innings × 11 games = 198 bench slots across roughly 10 active
  // players each game ≈ 18–22 bench innings per player.
  const seasonOffset = gameIdx * 2;

  for (let inning = 0; inning < 6; inning++) {
    const inningNum = inning + 1;
    const pitcherId = pitcherByInning[inning] || PLAYER_ORDER[1];
    const taken = new Set<string>();
    const lineup: Array<{ id: string; position: string }> = [];

    // Pitcher first.
    if (available.includes(pitcherId)) {
      lineup.push({ id: pitcherId, position: 'P' });
      taken.add(pitcherId);
    }

    // Catcher next — Brooks if available, else Davis as backup C.
    const catcher = available.find(pid =>
      !taken.has(pid) && PRIMARY_POSITION[pid] === 'C'
    );
    if (catcher) {
      lineup.push({ id: catcher, position: 'C' });
      taken.add(catcher);
    } else {
      const backup = available.find(pid => !taken.has(pid) && pid === 'dp_davis');
      if (backup) {
        lineup.push({ id: backup, position: 'C' });
        taken.add(backup);
      }
    }

    // Determine which 3 players sit this inning.
    const benchCount = Math.max(0, available.length - 9);
    const benchStart = (inning + seasonOffset) % Math.max(1, available.length);
    const benched = new Set<string>();
    let cursor = benchStart;
    let attempts = 0;
    while (benched.size < benchCount && attempts < available.length * 2) {
      const candidate = available[cursor % available.length];
      // Never bench the pitcher or starting catcher this inning.
      if (!taken.has(candidate) && !benched.has(candidate)) {
        benched.add(candidate);
      }
      cursor++;
      attempts++;
    }

    // Fill out the rest of the lineup using each player's preferred positions.
    const positionsTaken = new Set(lineup.map(l => l.position));
    available.forEach(pid => {
      if (taken.has(pid) || benched.has(pid)) return;
      const prefs = FALLBACK_POSITIONS[pid] || [PRIMARY_POSITION[pid]];
      const slot = prefs.find(pos => !positionsTaken.has(pos)) || 'EH';
      lineup.push({ id: pid, position: slot });
      positionsTaken.add(slot);
      taken.add(pid);
    });

    // Bench entries.
    benched.forEach(pid => {
      lineup.push({ id: pid, position: 'BENCH' });
    });

    // Sort lineup by PLAYER_ORDER for deterministic output.
    lineup.sort((a, b) => PLAYER_ORDER.indexOf(a.id) - PLAYER_ORDER.indexOf(b.id));

    logs[inningNum.toString()] = lineup;
  }

  return logs;
}

const GAME_INNING_LOGS = Object.fromEntries(
  GAME_IDS.map((gid, idx) => [gid, generateInningLogsForGame(gid, idx)])
);

// ─── Game templates ─────────────────────────────────────────────────────────

export const DEMO_GAMES_TEMPLATE = [
  { id: 'g1',  opponent: 'Westlake Warriors',    date: '2026-03-15T12:00', isHome: false, status: 'completed', result: { myScore: 4,  opponentScore: 2, outcome: 'W' }, stats: GAME_STATS.g1,  inningLogs: GAME_INNING_LOGS.g1 },
  { id: 'g2',  opponent: 'Eastside Eagles',       date: '2026-03-22T12:00', isHome: true,  status: 'completed', result: { myScore: 6,  opponentScore: 3, outcome: 'W' }, stats: GAME_STATS.g2,  inningLogs: GAME_INNING_LOGS.g2 },
  { id: 'g3',  opponent: 'Northgate Navigators',  date: '2026-03-29T12:00', isHome: true,  status: 'completed', result: { myScore: 3,  opponentScore: 7, outcome: 'L' }, stats: GAME_STATS.g3,  inningLogs: GAME_INNING_LOGS.g3 },
  { id: 'g4',  opponent: 'Hillcrest Hawks',       date: '2026-04-05T10:00', isHome: false, status: 'completed', result: { myScore: 8,  opponentScore: 1, outcome: 'W' }, stats: GAME_STATS.g4,  inningLogs: GAME_INNING_LOGS.g4 },
  { id: 'g5',  opponent: 'Creekside Cougars',     date: '2026-04-12T11:00', isHome: true,  status: 'completed', result: { myScore: 5,  opponentScore: 4, outcome: 'W' }, stats: GAME_STATS.g5,  inningLogs: GAME_INNING_LOGS.g5 },
  { id: 'g6',  opponent: 'Westlake Warriors',     date: '2026-04-19T10:00', isHome: true,  status: 'completed', result: { myScore: 2,  opponentScore: 5, outcome: 'L' }, stats: GAME_STATS.g6,  inningLogs: GAME_INNING_LOGS.g6 },
  { id: 'g7',  opponent: 'Ridgeline Reds',        date: '2026-04-26T12:00', isHome: false, status: 'completed', result: { myScore: 7,  opponentScore: 3, outcome: 'W' }, stats: GAME_STATS.g7,  inningLogs: GAME_INNING_LOGS.g7 },
  { id: 'g8',  opponent: 'Eastside Eagles',       date: '2026-05-03T11:00', isHome: false, status: 'completed', result: { myScore: 4,  opponentScore: 6, outcome: 'L' }, stats: GAME_STATS.g8,  inningLogs: GAME_INNING_LOGS.g8 },
  { id: 'g9',  opponent: 'Northgate Navigators',  date: '2026-05-10T10:00', isHome: true,  status: 'completed', result: { myScore: 9,  opponentScore: 2, outcome: 'W' }, stats: GAME_STATS.g9,  inningLogs: GAME_INNING_LOGS.g9 },
  { id: 'g10', opponent: 'Hillcrest Hawks',       date: '2026-05-17T12:00', isHome: true,  status: 'completed', result: { myScore: 6,  opponentScore: 8, outcome: 'L' }, stats: GAME_STATS.g10, inningLogs: GAME_INNING_LOGS.g10 },
  { id: 'g11', opponent: 'Creekside Cougars',     date: '2026-05-24T11:00', isHome: false, status: 'completed', result: { myScore: 5,  opponentScore: 3, outcome: 'W' }, stats: GAME_STATS.g11, inningLogs: GAME_INNING_LOGS.g11 },
  { id: 'g12', opponent: 'Ridgeline Reds',        date: '2026-05-31T10:00', isHome: true,  status: 'scheduled', stats: {} },
  { id: 'g13', opponent: 'Westlake Warriors',     date: '2026-06-07T12:00', isHome: false, status: 'scheduled', stats: {} },
  { id: 'g14', opponent: 'Eastside Eagles',       date: '2026-06-14T11:00', isHome: true,  status: 'scheduled', stats: {} },
];

// Pre-generated Smart Scout response for demo sessions.
// Returned instantly from the server — no Claude API call made.
export const DEMO_INSIGHTS = {
  teamInsight: {
    observations: [
      "The Thunder are putting up a .342 team OBP, which is solid for 12U AAA, but the lineup is carrying a .228 average in the 7-9 spots that's dragging the run-scoring down. The top of the order gets on base; the middle of the order isn't cashing them in at the rate the OBP should produce.",
      "Pitching staff ERA sits around 3.8, which is right at the average-to-solid line for this level, but the walks are a real story: the staff is issuing nearly 4 per 7 innings. When the control is on, this staff is genuinely hard to score on. When it isn't, the pitch counts climb fast and you're into the back of the bullpen by the 4th.",
      "The 7-4 record is real, but three of those four losses came in games where the opponent scored 5 or more in a single inning. This team doesn't have a run-prevention problem. It has an inning-implosion problem. One big frame is sinking otherwise competitive games.",
    ],
    suggestion: "Run a bullpen session focused entirely on first-pitch strikes. Getting ahead 0-1 versus falling behind 1-0 is the single biggest driver of walk rate at this level. Track first-pitch-strike percentage for each arm for two weeks and use it as your rotation-decision data.",
  },
  playerInsights: [
    {
      playerId: 'dp_rivera',
      name: 'Marcus Rivera',
      observations: [
        "Rivera is your best all-around player and he knows how to use it: .355 AVG, .447 OBP, and 10 runs scored in 11 games. He's getting on base in nearly half his plate appearances, and the speed to go with it means he's creating pressure every time he reaches.",
        "His last three games show the cold streak starting to show: 0-for-3 in g11 after going 1-for-3 in g9 and g10. The season numbers are still excellent, but watch this over the next two games before drawing conclusions.",
      ],
      suggestion: "Keep Rivera at the top of the order regardless of matchup. Consider limiting his pitching appearances to two per month to protect the most valuable arm/bat combination on your roster.",
    },
    {
      playerId: 'dp_thompson',
      name: 'Jake Thompson',
      observations: [
        "Thompson is your ace and the numbers back it up: two outings totaling 10 innings, 11 strikeouts, and only 3 earned runs combined. His g4 start (5 IP, 1 ER, 6 K) was his best outing of the season by a wide margin.",
        "At the plate he's streaky: .292 AVG but 8 strikeouts in 24 at-bats. His last two games at the dish were quiet (0-for-2, 0-for-2). Worth watching whether pitching workload is affecting his approach in the box.",
      ],
      suggestion: "Give Thompson an extra day of rest between his pitching starts and batting practice. At this age, mental load from pitching can quietly bleed into hitting approach.",
    },
    {
      playerId: 'dp_walsh',
      name: 'Connor Walsh',
      observations: [
        "Walsh has the highest RBI total on the team (11) and a .862 OPS. He's your cleanup hitter in every meaningful sense. The power is real. The problem is the 9 strikeouts: he went 0-for-3 with 2 K in g2, and the strikeout rate is climbing in his last 3 games.",
        "Opposing pitchers are figuring out they can get him out of the zone. He's chasing breaking balls down and in. The game arc from g7 through g11 shows increasing swing-and-miss on pitches he should be laying off.",
      ],
      suggestion: "In batting practice, feed Walsh a steady diet of low-and-away breaking balls and have him focus on driving them the other way. The pull-happy approach is what pitchers are exploiting right now.",
    },
    {
      playerId: 'dp_lee',
      name: 'Mason Lee',
      observations: [
        "Lee is struggling: .176 AVG, 6 strikeouts in 17 at-bats, and only 3 hits across 9 games. His last five game lines are 0-for-2, 0-for-1 (BB), 0-for-2, 0-for-2, and 0-for-2. That's an 0-for-9 stretch with zero balls put in play productively.",
        "He sat out g4, which may have disrupted his rhythm. The strikeout rate and the inability to put the ball in play at all over the last five games suggests he's either guessing wrong or his confidence has collapsed at the plate.",
      ],
      suggestion: "Move Lee to the 9-hole for two weeks and give him explicit permission to just make contact, no trying to do too much. Focused short-game tee work, not power drills. Confidence at the plate is a skill, and right now his is eroding.",
    },
  ],
};
